import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ServiceRedesign.css';

interface IServiceRedesignProps {
  title: string;
  url: string;
  image?: string | null;
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const ServiceRedesign: React.FC<IServiceRedesignProps> = ({ title, url, image, onClick }) => {
  return (
    <a href={url} className={styles['container']} onClick={onClick}>
      {image ? <img src={image} alt={title} /> : null}
      <UIText3 textAlign="center">{title}</UIText3>
    </a>
  );
};
